import React, { useState } from 'react'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism'
import { Copy, Check } from 'lucide-react'

interface CodeExampleProps {
    code: string
    language: string
    showHeader?: boolean
}

const CodeExample: React.FC<CodeExampleProps> = ({ code, language, showHeader = true }) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = () => {
        navigator.clipboard.writeText(code)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <div className="code-block-container">
            {showHeader && (
                <div className="code-block-header">
                    <span className="code-block-language">{language}</span>
                    <button className="code-block-copy-button" onClick={handleCopy}>
                        {copied ? (
                            <>
                                <Check size={14} style={{ marginRight: '4px', display: 'inline-block', verticalAlign: 'middle' }} />
                                Copied!
                            </>
                        ) : (
                            <>
                                <Copy size={14} style={{ marginRight: '4px', display: 'inline-block', verticalAlign: 'middle' }} />
                                Copy
                            </>
                        )}
                    </button>
                </div>
            )}
            <div className="code-block-content">
                <SyntaxHighlighter
                    language={language}
                    style={vscDarkPlus}
                    customStyle={{
                        margin: 0,
                        borderRadius: showHeader ? '0 0 6px 6px' : '6px',
                        fontSize: '13px'
                    }}
                >
                    {code}
                </SyntaxHighlighter>
            </div>
        </div>
    )
}

export default CodeExample
